
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createGoal } from "../database-goals";
import { goalQueryKeys } from "../operations/goal-query-keys";
import { useUser } from "@/hooks/auth/use-user";
import { GoalCreationInput } from "../goal-types";

export function useAddGoalMutation() {
  const queryClient = useQueryClient();
  const { user } = useUser();
  return useMutation({
    mutationFn: async (goalInput: GoalCreationInput) => {
      if (!user) throw new Error("Not signed in");
      return await createGoal(goalInput, user.id);
    },
    onSuccess: (_, __, context) => {
      if (!user) return;
      queryClient.invalidateQueries({ queryKey: goalQueryKeys.user(user.id) });
    }
  });
}
